import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';
import { ToggleButton } from 'vue-js-toggle-button';

@Component({
  name: 'bpc-input',
  components: {
    'bpc-field-wrapper': FieldWrapper,
    ToggleButton,
  },
})
export default class SwitchButton extends mixins(AbstractField) {
  @Prop([String, Number]) readonly value: string | number;
  @Prop(Array) readonly options: object[];

  get model(): string | number {
    return this.value;
  }
  set model(val: string | number) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }

  // onEnterKey() {
  //   this.$emit('enter-key');
  // }

  // updated () { }

  // destroyed () { }
}
